import request from "@/utils/request";

// 获取物品列表
export function getList(data) {
  return request.post("/wms/materialinfo/queryPage", data);
}

// 新增修改物品
export function edit(data) {
  return request.post(
    `/wms/materialinfo/${data.id ? "updateById" : "insert"}`,
    data
  );
}

// 删除物品
export function del(id) {
  return request.get("/wms/materialinfo/deleteById/" + id);
}

// find materialinfo by item id
export function findById(id) {
  return request.get("/wms/materialinfo/findById/" + id);
}
